import { useState } from 'react';
import { formatDateTime } from '../../utils/dateUtils';

export default function PhotoGallery({ photos, onDelete, deletingId }) {
  const [selected, setSelected] = useState(null);

  if (!photos || photos.length === 0) return null;

  return (
    <div className="photo-gallery">
      <div className="photo-grid">
        {photos.map(photo => (
          <div key={photo.id} className="photo-thumb" style={{ minWidth: 80, minHeight: 80, position: 'relative' }}>
            <div onClick={() => setSelected(photo)} style={{ cursor: 'pointer' }}>
              <img src={`/api/uploads/${photo.file_path}`} alt={photo.context || 'Photo'} />
              <span className="photo-context">{photo.context === 'creation' ? 'Creation' : 'Resolution'}</span>
            </div>
            {onDelete && (
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); onDelete(photo.id); }}
                disabled={deletingId === photo.id}
                title="Delete photo"
                style={{
                  position: 'absolute', top: 4, right: 4,
                  width: 24, height: 24, borderRadius: '50%',
                  border: 'none', cursor: 'pointer',
                  background: 'rgba(220, 38, 38, 0.9)', color: '#fff',
                  fontWeight: 700, fontSize: 14, lineHeight: 1,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                }}
              >
                {deletingId === photo.id ? '…' : '×'}
              </button>
            )}
          </div>
        ))}
      </div>

      {selected && (
        <div className="photo-lightbox" onClick={() => setSelected(null)}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <button className="lightbox-close" onClick={() => setSelected(null)}>&times;</button>
            <img src={`/api/uploads/${selected.file_path}`} alt={selected.context || 'Photo'} />
            <div className="lightbox-info">
              <span>{selected.context === 'creation' ? 'Taken at Creation' : 'Taken at Resolution'}</span>
              <span>{formatDateTime(selected.created_at)}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
